import { createRouter, createWebHistory } from 'vue-router'
import qs from 'qs'
import { routes } from './routes'
import { useUserStore } from '@/lib/store/user'

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes,
	parseQuery: qs.parse,
	stringifyQuery: qs.stringify,

})

// router.beforeEach(async (to, from, next) => {
// 	const userStore = useUserStore()

// 	let user = userStore.me
// 	if (!user) {
// 		try {
// 			user = await userStore.checkUser()
// 		} catch (error) {
// 			user = null
// 			if (to.name != 'login') {
// 				return next({ name: 'login'})
// 			}
// 		}
// 	}

// 	if (to.matched[0]?.name == 'public') {
// 		// Main page
// 		if (!to.matched[1]) {
// 			if (user) {
// 				return next({ name: 'users' })
// 			}
// 		}
// 		return next()
// 	} else {
// 		if (!user && to.name != 'login') {
// 			return next({ name: 'login' })
// 		}
// 		if (user && !userStore.token?.claims?.tenantId) {
// 			return next({ name: 'interstitial' })
// 		}
// 	}

// 	return next()
// })

export default router
